module.exports = __webpack_public_path__ + "img/confirm.5a667ab4.png";